import api from '../api';
import { resolveAssetUrl } from './assets';

export const brandingIconUrl = (value) => value?.startsWith('/api/')
  ? resolveAssetUrl(value.slice(4))
  : value || '/nashicone.png';

export function applyLinkBranding({ title, faviconUrl }) {
  document.title = title || 'Nash iBPM';
  const icon = brandingIconUrl(faviconUrl);
  ['icon', 'apple-touch-icon'].forEach(rel => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) { link = document.createElement('link'); link.rel = rel; document.head.appendChild(link); }
    link.type = 'image/png';
    link.href = icon;
  });
  const metadata = { 'og:title': document.title, 'og:site_name': document.title, 'og:image': new URL(icon, window.location.origin).href, 'twitter:title': document.title, 'twitter:image': new URL(icon, window.location.origin).href };
  Object.entries(metadata).forEach(([key, content]) => {
    const attribute = key.startsWith('og:') ? 'property' : 'name';
    let meta = document.querySelector(`meta[${attribute}="${key}"]`);
    if (!meta) { meta = document.createElement('meta'); meta.setAttribute(attribute, key); document.head.appendChild(meta); }
    meta.content = content;
  });
}

export async function loadPublicLinkBranding() {
  try {
    const { data } = await api.get('/link-branding/public');
    if (typeof data?.title === 'string' && typeof data?.faviconUrl === 'string') applyLinkBranding(data);
  } catch {
    // The published HTML already contains the last saved identity.
  }
}
